import { ticketStatsApi } from '@src/@data/api/ticketStats';
import { useCompany } from '@src/@data/store/CompanyProvider';
import { useEffect, useState } from 'react';
import { logOnError } from '../errors';

export const useAreTicketsAvailable = () => {
  const { selectedCompanyId } = useCompany();
  const [areTicketsAvailable, setAreTicketsAvailable] = useState(false);

  useEffect(() => {
    if (!selectedCompanyId) {
      return;
    }
    ticketStatsApi
      .areTicketsAvailable(selectedCompanyId)
      .then((res) => setAreTicketsAvailable(res.hasTickets))
      .catch((e) => {
        setAreTicketsAvailable(false);
        logOnError(e);
      });
  }, [selectedCompanyId]);

  return areTicketsAvailable;
};
